<template>
  <keep-alive :include="$store.getters.catch_components">
    <router-view v-if="$store.getters.isContentReload && $store.getters.isRightReload"></router-view>
  </keep-alive>
    <!--<router-view></router-view>-->
</template>

<script>
  import catchContentJs from "./catchContent.js"

  export default catchContentJs
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/layout/catchContent/catchContent.vue